import React from 'react'
import { Card, Statistic } from 'antd'
import { BarChartOutlined } from '@ant-design/icons'

export interface CompletedTodayStats {
  completed_today?: number
  completed_leads?: number
}

export default function CompletedTodayCard({
  stats,
}: {
  stats?: CompletedTodayStats | null
}) {
  return (
    <Card>
      <Statistic
        title="Completed Today"
        value={stats?.completed_today ?? 0}
        prefix={<BarChartOutlined />}
      />
    </Card>
  )
}
